import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ROOT } from "../../../utils/api-config";

export const cashoutApi = createApi({
  reducerPath: "CashoutApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.currentAgent.access_token;
      headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Cashout"],
  endpoints: (builder) => ({
    billFees: builder.mutation({
      query: (payload) => ({
        url: "/api/frais/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Cashout"],
    }),

    cashoutGetInfoMore: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/external_pickup/get/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Cashout"],
    }),

    cashoutMore: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/external_pickup/pay/",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Cashout"],
    }),
  }),
});

export const {
  useCashoutGetInfoMoreMutation,
  useCashoutMoreMutation
} = cashoutApi;
